module.exports = __webpack_public_path__ + "assets/113f79ebf3f6e6ec125ef8044d2010e6.svg";